import React, { Fragment, useEffect } from 'react'
import DashboardFooter from '../components/dashboard/DashboardFooter'
import DashboardNavbar from '../components/dashboard/DashboardNavbar'
import DashboardSidebar from '../components/dashboard/DashboardSidebar'
import PaymentsListMainConponent from '../components/payments/PaymentsListMainConponent'
import { authCheck } from '../services/auth'
import { useNavigate } from 'react-router-dom'

export default function PaymentsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!authCheck()) {
      return navigate('/login');
    }
  }, []);
  return (
    <Fragment>
      {authCheck() ? <section className="dashboard-main-section">
        <DashboardSidebar />
        <div className="dashboard-right-part">
          <DashboardNavbar />
          <PaymentsListMainConponent />
          <DashboardFooter />
        </div>
      </section> : null}
    </Fragment>
  )
}
